import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTriangleRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.12843 4.96646C6.62844 4.67426 6 5.03488 6 5.61399V18.386C6 18.9651 6.62844 19.3257 7.12843 19.0335L17.9079 12.7339C18.4693 12.4057 18.4693 11.5943 17.9079 11.2661L7.12843 4.96646ZM4.5 5.61399C4.5 3.87665 6.38531 2.7948 7.88528 3.6714L18.6647 9.97107C20.2171 10.8783 20.2171 13.1217 18.6647 14.0289L7.88528 20.3286C6.38531 21.2052 4.5 20.1233 4.5 18.386V5.61399Z",
		fill: "currentColor"
	})
});
export { SvgIconTriangleRight as ReactComponent };
